import { postApiRequest } from 'api';

export const postEvaluate = (id: string): Promise<[]> => {
    return postApiRequest(`/assignment-progress/evaluate/${id}/`);
};
